import React, { useState } from "react";
import {
    Form,
    Input,
    Button,
    Typography,
    message,
    Spin,
    Divider,
    Row,
    Col
} from "antd";
import {
    COMMON_ERROR_MSG,
    SESSION_TOKEN
} from "../../../constants/constants";
import LeftLayout from "../../pageHeader/LeftLayout";
import _capitalProviderService from "../../../modules/capitalProviderService";
import { useHistory } from "react-router-dom";
import { routes } from "../../../routes/Routes";
import { RightOutlined } from "@ant-design/icons";
import Login from "../../../components/Login/Login";

import "../../../assets/dist/ConsumerProject/Common.css";

const { Title, Link } = Typography;

const CapitalProviderLogin = () => {
    const [loading, setLoading] = useState(false);
    const history = useHistory();

    // const createNewAccount = () => {
    //     history.push(routes.createCapitalProviderAccount.path);
    // };

    const administratorLogin = () => {
        history.push(routes.administratorLogin.path);
    };

    const consumerLogin = () => {
        history.push(routes.registeredEmail.path);
    };

    const forgotPassword = () => {
        history.push(routes.forgotCapitalProviderLoginPasswordSendOTP.path);
    };

    const handleConfirmSendOTP = async (values) => {
        let reqObj = {
            Email: values.email,
            Password: values.password,
        }
        setLoading(true);
        try {
            const res = await _capitalProviderService.loanOfficerLogin(reqObj);
            if (res.data.IsSuccess) {
                setLoading(false);
                localStorage.setItem(SESSION_TOKEN, res?.data?.Obj.AuthToken);
                localStorage.setItem("userRole", res?.data?.Obj?.Role);
                localStorage.setItem("capitalProviderUserId", res?.data?.Obj?.Id);
                localStorage.setItem("capitalProviderLoginEmail", reqObj.Email);
                localStorage.setItem("capitalProviderFirstName", res?.data?.Obj?.FirstName);
                localStorage.setItem("IsConsumerFlag", JSON.stringify(false));
                localStorage.setItem("IsAdministratorFlag", JSON.stringify(false));
                localStorage.setItem("IsCapitalProviderFlag", JSON.stringify(true));
                history.push({
                    pathname: routes.capitalProviderDashboard.path,
                    state: { "email": values.email }
                });
            } else {
                setLoading(false);
                message.error(res.data.Message || COMMON_ERROR_MSG);
            }
        } catch (err) {
            setLoading(false);
            console.log(err);
        }
    };

    const onFinish = (values) => {
        handleConfirmSendOTP(values);
    };

    return (
        <Spin spinning={loading}>
            <Login 
                role="capitalProvider"
                title="Capital Provider Portal"
                onFinishHandle={onFinish}
                forgotPassword={forgotPassword}
                administratorLogin={administratorLogin}
                consumerLogin={consumerLogin}
                isNewAccountCreateFlag={false}
            />
            {/* <LeftLayout>
                <div className="w450 login-page">
                    <Title className="pageTitle" level={3}>
                        Capital Provider Portal
                    </Title>

                    <Form
                        name="verify-email"
                        layout="vertical"
                        onFinish={onFinish}
                        requiredMark={true}
                    >
                        <Form.Item
                            label="Email"
                            name="email"
                            rules={[
                                {
                                    required: true,
                                    message: "Email is required",
                                },
                                { type: 'email', message: 'Enter a valid Email' }
                            ]}
                        >
                            <Input
                                placeholder="Enter Email"
                                autoComplete="email"
                                maxLength={50}
                            />
                        </Form.Item>

                        <Form.Item
                            label="Password"
                            name="password"
                            rules={[{ required: true, message: "Password is required" }]}
                        >
                            <Input.Password
                                autoComplete="current-password"
                                placeholder="Enter Password"
                                maxLength={30}
                            />
                        </Form.Item>
                        <div className="forgot-text forgTxt">
                            <Link
                                onClick={forgotPassword}
                                className="fbold"
                            >
                                Forgot Password? <RightOutlined />
                            </Link>
                        </div>
                        <Row justify="space-between" align="middle" className="mt8">
                            <Col>
                                <Form.Item className="mb0">
                                    <Button
                                        htmlType="submit"
                                        className="login-btn loginBtn"
                                        shape="round"
                                    >
                                        Login <RightOutlined />
                                    </Button>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Divider plain orientation="center">
                            OR
                        </Divider>

                        <Form.Item className="mt20 mb10">
                            <Link onClick={consumerLogin}>
                                Investor Login <RightOutlined />
                            </Link>
                        </Form.Item>
                        <Form.Item>
                            <Link onClick={administratorLogin}>
                                Administrator Login <RightOutlined />
                            </Link>
                        </Form.Item>
                    </Form>
                </div>
            </LeftLayout> */}
        </Spin>
    );
};

export default CapitalProviderLogin;